import React, { useEffect, useState } from "react";
import "./IntermediateCoursePage.css";
import stick1 from "../../../Assets/express.jpg"
import stick2 from "../../../Assets/handle.jpg"
import stick3 from "../../../Assets/grammar.jpg"
import PopupForm from "../../../Form/PopupForm";
const IntermediateCoursePage = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showForm, setShowForm] = useState(false);
    const handleOpenForm = () => setShowForm(true);
  const handleCloseForm = () => setShowForm(false);

  useEffect(() => {
    setIsVisible(true);

    const animateOnScroll = () => {
      const elements = document.querySelectorAll(
        ".intermediate-animate-on-scroll"
      );

      elements.forEach((element) => {
        const elementTop = element.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;

        if (elementTop < windowHeight - 100) {
          element.classList.add("intermediate-visible");
        }
      });
    };

    window.addEventListener("scroll", animateOnScroll);
    animateOnScroll(); // Initial check

    return () => window.removeEventListener("scroll", animateOnScroll);
  }, []);

  return (
    <div className="intermediate-page">
      {/* Hero Section */}
     <section className="intermediate-hero-section">
        <div
          className={`intermediate-hero-content ${
            isVisible ? "intermediate-visible" : ""
          }`}
        >
          <div className="intermediate-decorative-circle"></div>
          <div className="intermediate-decorative-circle intermediate-circle-2"></div>
          <h1>
            INTERMEDIATE LEVEL{" "}
            <span className="intermediate-highlight">CONFIDENCE BUILDER!</span>
          </h1>
          <p className="intermediate-tagline">
            Express opinions, handle real-life conversations, and use tenses
            fluently.
          </p>    
          <div className="intermediate-cta-container">
            <button onClick={handleOpenForm} className="intermediate-cta-button">
              Start Your Journey 
            </button>
            {/* Make free trial badge clickable */}
            <div 
              onClick={handleOpenForm} 
              className="intermediate-free-trial-badge" 
              style={{ cursor: 'pointer' }}
              role="button" 
              tabIndex={0}
              onKeyPress={(e) => { if(e.key === 'Enter' || e.key === ' ') handleOpenForm(); }}
            >
              <span>FREE TRIAL</span>
              <div className="intermediate-pulse"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Course Promise Section */}
      <section className="intermediate-course-promise intermediate-animate-on-scroll">
        <div className="intermediate-shadow-box">
          <h2>ELEVATE YOUR ENGLISH COMMUNICATION</h2>
          <div className="intermediate-promise-content">
            <div className="intermediate-decorative-ring"></div>
            <p>
              At this{" "}
              <span className="intermediate-highlight">INTERMEDIATE LEVEL</span>
              , you will be able to express opinions, handle real-life
              conversations, describe events and situations, and use tenses and
              vocabulary more fluently.
            </p>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="intermediate-benefits-section intermediate-animate-on-scroll">
        <h2>WHAT YOU'LL ACHIEVE</h2>
        <div className="intermediate-benefits-container">
          <div className="intermediate-benefit-card">
            <img
              src={stick1}
              alt="Express Opinions"
              className="intermediate-benefit-image"
            />
            <h3>Express Opinions</h3>
            <p>
              Articulate your thoughts and share your perspective on various
              topics with clarity and confidence
            </p>
          </div>
          <div className="intermediate-benefit-card">
            <img
              src={stick2}
              alt="Handle Real-Life Conversations"
              className="intermediate-benefit-image"
            />
            <h3>Handle Real-Life Conversations</h3>
            <p>
              Navigate complex social and professional interactions with
              improved fluency and naturalness
            </p>
          </div>
          <div className="intermediate-benefit-card">
            <img
              src={stick3}
              alt="Advanced Grammar"
              className="intermediate-benefit-image"
            />
            <h3>Advanced Grammar</h3>
            <p>
              Master tenses and vocabulary to communicate more effectively in
              various contexts
            </p>
          </div>
        </div>
      </section>

      {/* Course Structure Section */}
       <section class="intermediate-course-structure intermediate-animate-on-scroll">
        <h2>YOUR 30-DAY TRANSFORMATION</h2>
        <div class="intermediate-timeline">
             {/* Stick Figure */}
            <div class="stick-figure">
                <svg viewBox="0 0 30 40" xmlns="http://www.w3.org/2000/svg">
                     {/* Head */}
                    <circle cx="15" cy="6" r="4" stroke="#333" stroke-width="2" fill="none"/>
                     {/* Body */}
                    <line x1="15" y1="10" x2="15" y2="25" stroke="#333" stroke-width="2"/>
                     {/* Arms */}
                    <line x1="15" y1="15" x2="8" y2="20" stroke="#333" stroke-width="2"/>
                    <line x1="15" y1="15" x2="22" y2="20" stroke="#333" stroke-width="2"/>
                     {/* Legs */}
                    <line x1="15" y1="25" x2="8" y2="35" stroke="#333" stroke-width="2"/>
                    <line x1="15" y1="25" x2="22" y2="35" stroke="#333" stroke-width="2"/>
                     {/* Hands */}
                    <circle cx="8" cy="20" r="1.5" fill="#333"/>
                    <circle cx="22" cy="20" r="1.5" fill="#333"/>
                     {/* Feet */}
                    <circle cx="8" cy="35" r="1.5" fill="#333"/>
                    <circle cx="22" cy="35" r="1.5" fill="#333"/>
                </svg>
            </div>

            <div class="intermediate-timeline-item">
                <div class="intermediate-timeline-point"></div>
                <div class="intermediate-timeline-content">
                    <h3>Week 1: Refreshing Grammar</h3>
                    <p>
                        Kick-start your fluency by refreshing essential grammar and
                        building a foundation for advanced communication
                    </p>
                </div>
            </div>
            <div class="intermediate-timeline-item">
                <div class="intermediate-timeline-point"></div>
                <div class="intermediate-timeline-content">
                    <h3>Week 2: Opinion Expression</h3>
                    <p>
                        Learn to express opinions confidently and make suggestions in
                        both casual and formal settings
                    </p>
                </div>
            </div>
            <div class="intermediate-timeline-item">
                <div class="intermediate-timeline-point"></div>
                <div class="intermediate-timeline-content">
                    <h3>Week 3: Group Discussions</h3>
                    <p>
                        Participate effectively in group discussions on daily life
                        topics and workplace conversations
                    </p>
                </div>
            </div>
            <div class="intermediate-timeline-item">
                <div class="intermediate-timeline-point"></div>
                <div class="intermediate-timeline-content">
                    <h3>Week 4: Professional Communication</h3>
                    <p>
                        Master speaking in the workplace with impact and practice for
                        interviews and presentations
                    </p>
                </div>
            </div>
        </div>
    </section>

      {/* Course Components Section */}
      <section className="intermediate-course-components intermediate-animate-on-scroll">
        <h2>COMPREHENSIVE COURSE COMPONENTS</h2>
        <div className="intermediate-components-grid">
          <div className="intermediate-component-card">
            <div className="intermediate-component-number">01</div>
            <h3>Kick Starting Fluency</h3>
            <p>
              Refreshing grammar fundamentals with practical application in real
              conversations
            </p>
            <svg className="card-stick-figure" width="35" height="50" viewBox="0 0 35 50">
              <g className="stick-figure">
                <circle cx="17" cy="7" r="5" />
                <line x1="17" y1="12" x2="17" y2="30" />
                <line x1="17" y1="18" x2="10" y2="25" />
                <line x1="17" y1="18" x2="24" y2="25" />
                <line x1="17" y1="30" x2="10" y2="45" />
                <line x1="17" y1="30" x2="24" y2="45" />
                {/* Speaking bubble */}
                <circle cx="28" cy="12" r="4" stroke-width="1" />
                <path d="M24 14 L22 16" stroke-width="1" />
              </g>
            </svg>
          </div>
          <div className="intermediate-component-card">
            <div className="intermediate-component-number">02</div>
            <h3>Expressing Opinions</h3>
            <p>
              Learn techniques for articulating thoughts and making suggestions
              effectively
            </p>
             <svg className="card-stick-figure" width="50" height="50" viewBox="0 0 50 50">
              <g className="stick-figure">
                {/* Two figures role playing */}
                <circle cx="12" cy="7" r="4" />
                <line x1="12" y1="11" x2="12" y2="25" />
                <line x1="12" y1="16" x2="8" y2="20" />
                <line x1="12" y1="16" x2="16" y2="20" />
                <line x1="12" y1="25" x2="8" y2="35" />
                <line x1="12" y1="25" x2="16" y2="35" />
                
                <circle cx="35" cy="7" r="4" />
                <line x1="35" y1="11" x2="35" y2="25" />
                <line x1="35" y1="16" x2="31" y2="20" />
                <line x1="35" y1="16" x2="39" y2="20" />
                <line x1="35" y1="25" x2="31" y2="35" />
                <line x1="35" y1="25" x2="39" y2="35" />
                
                {/* Speech bubbles */}
                <ellipse cx="20" cy="12" rx="3" ry="2" stroke-width="1" />
                <ellipse cx="27" cy="12" rx="3" ry="2" stroke-width="1" />
              </g>
            </svg>
          </div>
          <div className="intermediate-component-card">
            <div className="intermediate-component-number">03</div>
            <h3>Group Discussion</h3>
            <p>
              Practice participating in discussions on daily life topics with
              confidence
            </p>
            <svg className="card-stick-figure" width="40" height="50" viewBox="0 0 40 50">
              <g className="stick-figure">
                <circle cx="20" cy="7" r="5" />
                <line x1="20" y1="12" x2="20" y2="30" />
                <line x1="20" y1="18" x2="12" y2="22" />
                <line x1="20" y1="18" x2="28" y2="22" />
                <line x1="20" y1="30" x2="15" y2="42" />
                <line x1="20" y1="30" x2="25" y2="42" />
                {/* Book/grammar symbol */}
                <rect x="26" y="15" width="8" height="6" stroke-width="1" />
                <line x1="28" y1="17" x2="32" y2="17" stroke-width="1" />
                <line x1="28" y1="19" x2="32" y2="19" stroke-width="1" />
              </g>
            </svg>
          </div>
          <div className="intermediate-component-card">
            <div className="intermediate-component-number">04</div>
            <h3>Workplace Communication</h3>
            <p>
              Master speaking in professional environments with clarity and
              impact
            </p>
            <svg className="card-stick-figure" width="45" height="50" viewBox="0 0 45 50">
              <g className="stick-figure stick-figure-happy">
                <circle cx="20" cy="7" r="5" />
                <line x1="20" y1="12" x2="20" y2="30" />
                <line x1="20" y1="18" x2="14" y2="22" />
                <line x1="20" y1="18" x2="26" y2="22" />
                <line x1="20" y1="30" x2="15" y2="42" />
                <line x1="20" y1="30" x2="25" y2="42" />
                {/* Words floating around */}
                <text x="30" y="12" font-size="4" fill="currentColor">ABC</text>
                <text x="32" y="25" font-size="4" fill="currentColor">XYZ</text>
                <text x="8" y="20" font-size="4" fill="currentColor">123</text>
              </g>
            </svg>
          </div>
          <div className="intermediate-component-card">
            <div className="intermediate-component-number">05</div>
            <h3>Peer Feedback Sessions</h3>
            <p>
              Gain insights from structured peer reviews to refine your
              communication style
            </p>
            <svg className="card-stick-figure" width="40" height="50" viewBox="0 0 40 50">
              <g className="stick-figure">
                <circle cx="18" cy="7" r="5" />
                <line x1="18" y1="12" x2="18" y2="30" />
                <line x1="18" y1="18" x2="12" y2="24" />
                <line x1="18" y1="18" x2="24" y2="24" />
                <line x1="18" y1="30" x2="13" y2="42" />
                <line x1="18" y1="30" x2="23" y2="42" />
                {/* Calendar/clock symbol */}
                <rect x="26" y="12" width="8" height="8" stroke-width="1" />
                <line x1="28" y1="14" x2="32" y2="14" stroke-width="1" />
                <line x1="30" y1="16" x2="30" y2="18" stroke-width="1" />
              </g>
            </svg>
          </div>
          <div className="intermediate-component-card">
            <div className="intermediate-component-number">06</div>
            <h3>Mock Interviews</h3>
            <p>
              Practice for job interviews and presentations with expert guidance
            </p>
             <svg className="card-stick-figure" width="45" height="50" viewBox="0 0 45 50">
              <g className="stick-figure stick-figure-excited">
                <circle cx="18" cy="7" r="5" />
                <line x1="18" y1="12" x2="18" y2="30" />
                <line x1="18" y1="18" x2="12" y2="15" />
                <line x1="18" y1="18" x2="24" y2="15" />
                <line x1="18" y1="30" x2="13" y2="42" />
                <line x1="18" y1="30" x2="23" y2="42" />
                {/* Chart/graph symbol */}
                <line x1="28" y1="25" x2="40" y2="25" stroke-width="1" />
                <line x1="28" y1="12" x2="28" y2="25" stroke-width="1" />
                <polyline points="28,22 32,18 36,20 40,15" stroke-width="1" fill="none" />
                {/* Happy face */}
                <circle cx="15" cy="5" r="0.5" fill="currentColor" />
                <circle cx="21" cy="5" r="0.5" fill="currentColor" />
                <path d="M14 9 Q18 11 22 9" stroke-width="1" />
              </g>
            </svg>
          </div>
        </div>
      </section>

      {/* Trainers Section */}
      <section className="intermediate-trainers-section intermediate-animate-on-scroll">
        <h2>LEARN FROM THE BEST</h2>
        <div className="intermediate-shadow-box intermediate-trainer-box">
          <div className="intermediate-decorative-circle intermediate-trainer-circle"></div>
          <h3>EXPERT TRAINERS WHO TRANSFORM LIVES</h3>
          <ul className="intermediate-trainer-features">
            <li>
              <span>Certified Business Communication Experts</span>
            </li>
            <li>
              <span>Specialized in professional English training</span>
            </li>
            <li>
              <span>International teaching experience</span>
            </li>
            <li>
              <span>Industry professionals with practical knowledge</span>
            </li>
          </ul>
          <p>
            Our trainers don't just teach English—they empower you to express
            yourself confidently in any professional or social setting.
          </p>
        </div>
      </section>

      {/* What You Get Section */}
      <section className="intermediate-what-you-get-section intermediate-animate-on-scroll">
        <h2>EVERYTHING YOU RECEIVE</h2>
        <div className="intermediate-features-container">
          <div className="intermediate-feature-item">
            <div className="intermediate-feature-icon intermediate-check-icon"></div>
            <p>30 days of intensive training</p>
          </div>
          <div className="intermediate-feature-item">
            <div className="intermediate-feature-icon intermediate-check-icon"></div>
            <p>Interactive group discussion sessions</p>
          </div>
          <div className="intermediate-feature-item">
            <div className="intermediate-feature-icon intermediate-check-icon"></div>
            <p>Workplace communication handbook</p>
          </div>

          <div className="intermediate-feature-item">
            <div className="intermediate-feature-icon intermediate-check-icon"></div>
            <p>Personalized feedback reports</p>
          </div>
          <div className="intermediate-feature-item">
            <div className="intermediate-feature-icon intermediate-check-icon"></div>
            <p>Mock interview preparation</p>
          </div>
          <div className="intermediate-feature-item">
            <div className="intermediate-feature-icon intermediate-check-icon"></div>
            <p>Access to practice community</p>
          </div>
        </div>
      </section>

      {/* Transformation Section */}
      <section className="intermediate-transformation-section intermediate-animate-on-scroll">
        <h2>YOUR TRANSFORMATION JOURNEY</h2>
        <div className="intermediate-before-after-container">
          <div className="intermediate-before-box">
            <h3>BEFORE</h3>
            <ul>
              <li>Struggling to express opinions</li>
              <li>Limited workplace communication</li>
              <li>Difficulty with complex grammar</li>
              <li>Hesitation in group discussions</li>
              <li>Lack of confidence in professional settings</li>
            </ul>
          </div>
          <div className="intermediate-arrow-transform">
            <div className="intermediate-arrow-body"></div>
            <div className="intermediate-arrow-head"></div>
          </div>
          <div className="intermediate-after-box">
            <h3>AFTER</h3>
            <ul>
              <li>Confidently expressing opinions</li>
              <li>Effective workplace communication</li>
              <li>Fluent use of tenses and vocabulary</li>
              <li>Active participation in group discussions</li>
              <li>Professional presentation skills</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section
        id="enroll"
        className="intermediate-pricing-section intermediate-animate-on-scroll"
      >
        <h2>INVEST IN YOUR FUTURE</h2>
        <div className="intermediate-pricing-box intermediate-shadow-box">
          <div className="intermediate-decorative-circle intermediate-pricing-circle"></div>
          <h3>INTERMEDIATE COURSE: CONFIDENCE BUILDER</h3>
          <div className="intermediate-price-tag">
            <span className="intermediate-price">for 30 days</span>
          </div>
          <div>
            <button onClick={handleOpenForm} className="intermediate-free-trial-badge-large">
              TRIAL FREE
            </button>
            <div className="intermediate-pulse-large"></div>
          </div>
          <button onClick={handleOpenForm} className="intermediate-enroll-button">
            Enroll Now
          </button>
        </div>
      </section>
<PopupForm isOpen={showForm} onClose={handleCloseForm} />
      {/* Final CTA Section */}
    </div>
  );
};

export default IntermediateCoursePage;
